import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { Collapse, IconButton } from '@material-tailwind/react';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NavList } from './NavList';
import { Profile } from './Profile';
import TextWinds from '../../common/TextWinds';
import { StudentNavList } from './StudentNavList';
import { useOutsideClick } from '../../../hooks/useOutsideClick';
import { checkToken } from '../../../api/utils/api/userApi';
import { logout } from '../../../api/utils/util-func';

/** 사이트 공통 상단 헤더. 로고, 메뉴(교사/학생 분기), 장바구니(교사만), 로그인/내 정보 */
export const MegaMenu = () => {
  const isStudent = localStorage.getItem('type') === 'STUDENT' ? true : false;
  const [openNav, setOpenNav] = useState(false);
  const { pathname } = useLocation();

  // 로그인 여부 확인
  // 1. 토큰이 있는지 확인
  // 2. 토큰 유무에 따라 로그인 여부 확인
  // 3. useEffect를 통해 토큰 사용가능한지 확인
  // 4. 토큰이 만료 되었다면 로그아웃 처리
  const token = localStorage.getItem('accessToken');
  const [isLogin, setIsLogin] = useState(token ? true : false);

  const ref = useOutsideClick(() => {
    setOpenNav(false);
  });

  const toggleOpenNav = () => setOpenNav((cur) => !cur);

  useEffect(() => {
    checkToken().then((res) => {
      if (res === 'EMPTY') return;

      if (res === 'EXPIRED') {
        logout(false);
        setIsLogin(false);
        return;
      }
      setIsLogin(true);
    });

    // 새로고침 없이 이동하므로 페이지가 바뀌면 모바일 메뉴를 닫는다
    setOpenNav(false);
  }, [pathname]);

  useEffect(() => {
    const onResize = () => window.innerWidth >= 960 && setOpenNav(false);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <header className="fixed left-0 top-0 z-[30] w-full bg-white shadow-card">
      <div className="w-full xl:mx-auto">
        <div className="flex h-[58px] items-center justify-between px-5 xl:h-[60px]">
          <Link to={'/'}>
            <img
              src={process.env.PUBLIC_URL + '/logo.png'}
              alt="JEBS 로고"
              className="h-[40px] w-[40px]"
            />
          </Link>

          <div className="mr-auto hidden lg:block">
            {isStudent ? <StudentNavList /> : <NavList />}
          </div>

          <IconButton
            size="sm"
            color="blue-gray"
            variant="text"
            className="ml-auto mr-2 lg:hidden"
            onClick={toggleOpenNav}
          >
            {openNav ? (
              <XMarkIcon className="h-6 w-6" strokeWidth={2} />
            ) : (
              <Bars3Icon className="h-6 w-6" strokeWidth={2} />
            )}
          </IconButton>

          <div className="lg:flex lg:items-center lg:gap-x-1">
            {isLogin ? (
              <div className="flex items-center gap-x-1">
                {!isStudent && (
                  <Link to={'/cart'}>
                    <div className="h-[35px] w-[35px]">
                      <img
                        src={
                          process.env.PUBLIC_URL + '/svg/icon/shopping-cart.svg'
                        }
                        alt="장바구니"
                        className="h-full w-full"
                      />
                    </div>
                  </Link>
                )}
                <Profile isStudent={isStudent} />
              </div>
            ) : (
              <Link to={'/signin'}>
                <TextWinds type={'title_h5'} color="purple5">
                  로그인
                </TextWinds>
              </Link>
            )}
          </div>
        </div>
        <div ref={ref}>
          <Collapse open={openNav}>
            {isStudent ? <StudentNavList /> : <NavList />}
          </Collapse>
        </div>
      </div>
    </header>
  );
};
